import type { ReactNode } from 'react';

export const symbol_timer_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M370-760h210q36 0 63 27t27 63v140q0 36-27 63t-63 27H410v160h220q16.67 0 28.33 11.74Q670-256.53 670-239.76q0 16.76-11.67 28.26Q646.67-200 630-200H370q-16.67 0-28.33-11.67Q330-223.33 330-240v-190q0-36 27-63t63-27h170v-160H370q-16.67 0-28.33-11.74Q330-703.47 330-720.24q0-16.76 11.67-28.26Q353.33-760 370-760Z"
		/>
	</svg>
);
